<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <b-overlay
      :show="show"
      :variant="variant"
      :opacity="opacity"
      :blur="blur"
      rounded="lg"
      spinner-variant="primary"
    >
      <div id="dashboard-analytics">
        <div class="vx-row">
          <div
            class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base"
          >
            <router-link :to="'/company/staff'">
              <div class="vx-card custom-height">
                <b-card class="pt-5">
                  <b-card-text class="text-center">
                    <feather-icon
                      svgClasses="w-7 h-7 text-primary stroke-current"
                      icon="UsersIcon"
                    />
                  </b-card-text>
                  <b-card-title class="text-center">
                    {{ countStaff }}
                  </b-card-title>
                  <b-card-text class="text-center">
                    {{ $t("TotalStaffs") }}
                  </b-card-text>
                </b-card>
              </div>
            </router-link>
          </div>

          <div
            class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base"
          >
            <router-link :to="'/company/department'">
              <div class="vx-card custom-height">
                <b-card class="pt-5">
                  <b-card-text class="text-center">
                    <feather-icon
                      svgClasses="w-7 h-7 text-warning stroke-current"
                      icon="BoxIcon"
                    />
                  </b-card-text>
                  <b-card-title class="text-center">
                    {{ countDepartment }}
                  </b-card-title>
                  <b-card-text class="text-center">
                    {{ $t("TotalDepartments") }}
                  </b-card-text>
                </b-card>
              </div>
            </router-link>
          </div>

          <div
            class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base"
          >
            <router-link :to="'/company/settings/notification'">
              <div class="vx-card custom-height">
                <b-card class="pt-5">
                  <b-card-text class="text-center">
                    <feather-icon
                      svgClasses="w-7 h-7 text-primary stroke-current"
                      icon="MessageSquareIcon"
                    />
                  </b-card-text>
                  <b-card-title class="text-center">
                    {{ countSms }}
                  </b-card-title>
                  <b-card-text class="text-center">
                    {{ $t("TotalSms") }}
                  </b-card-text>
                </b-card>
              </div>
            </router-link>
          </div>
          <div
            v-if="!unio_user"
            class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base"
          >
            <router-link :to="'/company/payments'">
              <div class="vx-card custom-height">
                <b-card class="pt-5">
                  <b-card-text class="text-center">
                    <feather-icon
                      svgClasses="w-7 h-7 text-success stroke-current"
                      icon="CalendarIcon"
                    />
                  </b-card-text>
                  <b-card-title class="text-center">
                    {{ totalRevenue }}
                  </b-card-title>
                  <b-card-text class="text-center">
                    {{ $t("TotalRevenue") }}
                  </b-card-text>
                </b-card>
              </div>
            </router-link>
          </div>
        </div>
        <div class="vx-row">
          <div
            class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base"
          >
            <router-link :to="'/company/appointment'">
              <div class="vx-card custom-height">
                <b-card class="pt-5">
                  <b-card-text class="text-center">
                    <feather-icon
                      svgClasses="w-7 h-7 text-primary stroke-current"
                      icon="CalendarIcon"
                    />
                  </b-card-text>
                  <b-card-title class="text-center">
                    {{ countAppointment }}
                  </b-card-title>
                  <b-card-text class="text-center">
                    {{ $t("TotalAppointments") }}
                  </b-card-text>
                </b-card>
              </div>
            </router-link>
          </div>
          <!-- Complete -->
          <div
            class="vx-col w-full sm:w-full md:w-1/4 lg:w-1/4 xl:w-1/4 mb-base"
          >
            <router-link :to="'/company/appointment'">
              <div class="vx-card custom-height">
                <b-card class="pt-5">
                  <b-card-text class="text-center">
                    <feather-icon
                      svgClasses="w-7 h-7 text-success stroke-current"
                      icon="CalendarIcon"
                    />
                  </b-card-text>
                  <b-card-title class="text-center">
                    {{ countCompleted }}
                  </b-card-title>
                  <b-card-text class="text-center">
                    {{ $t("CompletedAppointments") }}
                  </b-card-text>
                </b-card>
              </div>
            </router-link>
          </div>
          <!--  -->

          <!-- Pending -->
          <div
            class="vx-col w-full sm:w-full md:w-1/4 lg:w-1/4 xl:w-1/4 mb-base"
          >
            <router-link :to="'/company/appointment'">
              <div class="vx-card custom-height">
                <b-card class="pt-5">
                  <b-card-text class="text-center">
                    <feather-icon
                      svgClasses="w-7 h-7 text-warning stroke-current"
                      icon="CalendarIcon"
                    />
                  </b-card-text>
                  <b-card-title class="text-center">
                    {{ countPending }}
                  </b-card-title>
                  <b-card-text class="text-center">
                    {{ $t("PendingAppointments") }}
                  </b-card-text>
                </b-card>
              </div>
            </router-link>
          </div>
          <!--  -->

          <!-- Cancelled -->
          <div
            class="vx-col w-full sm:w-full md:w-1/4 lg:w-1/4 xl:w-1/4 mb-base"
          >
            <router-link :to="'/company/appointment'">
              <div class="vx-card custom-height">
                <b-card class="pt-5">
                  <b-card-text class="text-center">
                    <feather-icon
                      svgClasses="w-7 h-7 text-danger stroke-current"
                      icon="CalendarIcon"
                    />
                  </b-card-text>
                  <b-card-title class="text-center">
                    {{ countCancelled }}
                  </b-card-title>
                  <b-card-text class="text-center">
                    {{ $t("CancelledAppointments") }}
                  </b-card-text>
                </b-card>
              </div>
            </router-link>
          </div>
        </div>
        <div class="vx-row ml-1">
          <div
            class="vx-col w-full md:w-1/3 lg:w-1/3 xl:w-1/3 mb-base bcard-color vx-card"
          >
            <b-card :title="$t('AppointmentStatistics')">
              <div class="mb-20">
                <div
                  v-for="(app, index) in appSat"
                  :key="index"
                  :class="{ 'mt-4': index }"
                >
                  <div class="flex justify-between mt-4">
                    <div class="flex flex-col">
                      <span class="mb-1">{{ $t(app.label) }}</span>
                    </div>
                    <div class="flex flex-col text-right">
                      <span class="flex -mr-1">
                        <span class="mr-1">
                          <strong>{{ app.count }}</strong>
                        </span>
                      </span>
                    </div>
                  </div>
                  <vs-progress :percent="app.count"></vs-progress>
                </div>
              </div>
            </b-card>
          </div>

          <div class="vx-col w-full md:w-2/3">
            <chartjs-line-chart
              :title="appTitle"
              :data="appData"
              :options="appOptions"
              v-on:filterData="getAppFilterData"
            ></chartjs-line-chart>
          </div>
        </div>
        <div class="vx-row" v-if="!unio_user">
          <div class="vx-col w-full">
            <chartjs-bar-chart
              :title="revenueTitle"
              :data="revenueData"
              :options="revenueOptions"
              v-on:filterData="getRevenueFilterData"
            ></chartjs-bar-chart>
          </div>
        </div>

        <vx-card class="pt-5 vx-card">
          <div class="vx-row gauge">
            <div class="vx-col w-full md:w-3/4 lg:w-3/4 xl:w-3/4 mb-base">
              <h3>Occupation Rate</h3>

              <b-list-group>
                <b-list-group-item class="d-flex align-items-center mt-4" v-if="occupation_rate.company">
                  <b-avatar
                    class="mr-5"
                    size="45px"
                    href="#"
                    :src="occupation_rate.company.company_profile_image"
                    :variant="occupation_rate.company.variant"
                    :text="occupation_rate.company.avatar_text"
                  ></b-avatar>
                  <span class="occupation-title"
                    ><b>{{ occupation_rate.company.company_name }}</b
                    ><br />
                    <small>{{ $t("Company") }}</small></span
                  >
                  <span style="right: 26px; position: absolute">
                    <radial-progress-bar
                      :diameter="55"
                      :completed-steps="occupation_rate.company.occupation_rate"
                      :total-steps="totalSteps"
                      strokeWidth="4"
                      innerStrokeWidth="4"
                      startColor="#d5304d"
                      stopColor="#f1aa47"
                      innerStrokeColor="#eaeaea"
                    >
                      <p class="mt-5">
                        <b>{{ occupation_rate.company.occupation_rate }}%</b>
                      </p>
                    </radial-progress-bar>
                  </span>
                </b-list-group-item>
                <b-list-group-item
                  class="d-flex align-items-center"
                  v-for="(value, index) in occupation_rate.departments"
                  :key="index"
                >
                  <b-avatar
                    class="mr-5"
                    size="45px"
                    href="#"
                    :variant="value.variant"
                    :text="value.avatar_text"
                  ></b-avatar>
                  <span class="occupation-title"
                    ><b>{{ value.department_name }}</b
                    ><br />
                    <small>{{ $t("Department") }}</small></span
                  >
                  <span style="right: 26px; position: absolute">
                    <radial-progress-bar
                      :diameter="55"
                      :completed-steps="value.occupation_rate"
                      :total-steps="totalSteps"
                      strokeWidth="4"
                      innerStrokeWidth="4"
                      startColor="#d5304d"
                      stopColor="#f1aa47"
                      innerStrokeColor="#eaeaea"
                    >
                      <p class="mt-5">
                        <b>{{ value.occupation_rate }}%</b>
                      </p>
                    </radial-progress-bar>
                  </span>
                </b-list-group-item>

                <b-list-group-item
                  class="d-flex align-items-center"
                  v-for="(value, index) in occupation_rate.staffs"
                  :key="index"
                >
                  <b-avatar
                    class="mr-5"
                    size="45px"
                    href="#"
                    :src="value.staff_profile_image"
                    :variant="value.variant"
                    :text="value.avatar_text"
                  ></b-avatar>
                  <span class="occupation-title"
                    ><b>{{ value.first_name }} {{ value.last_name }}</b
                    ><br />
                    <small>{{ $t("StaffMember") }}</small></span
                  >
                  <span style="right: 26px; position: absolute">
                    <radial-progress-bar
                      :diameter="55"
                      :completed-steps="value.occupation_rate"
                      :total-steps="totalSteps"
                      strokeWidth="4"
                      innerStrokeWidth="4"
                      startColor="#d5304d"
                      stopColor="#f1aa47"
                      innerStrokeColor="#eaeaea"
                    >
                      <p class="mt-5">
                        <b>{{ value.occupation_rate }}%</b>
                      </p>
                    </radial-progress-bar>
                  </span>
                </b-list-group-item>
              </b-list-group>
              <!-- <vue-gauge v-if="showGauge" :refid="'mobile-unique-id'" :options="gaugeMobileOptions"></vue-gauge>
        <vue-gauge v-if="showGauge" :refid="'type-unique-id'" :options="gaugeOptions"></vue-gauge> -->
            </div>
            <div class="vx-col w-full md:w-1/4 lg:w-1/4 xl:w-1/4 mb-base">
              <v-select
                class="mt-2"
                size="sm"
                v-model="selectedMonth"
                :options="monthArr"
                label="month"
                :reduce="(label) => label.month"
                :placeholder="$t('SelectMonth')"
              >
                <template v-slot:option="option">
                  <span
                    :class="
                      currentMonth == option.month ? 'option-text-bold' : ''
                    "
                  >
                    {{ option.month }}
                  </span>
                </template>
              </v-select>
              <!-- <v-select class="mt-2"
                size="sm"
                v-model="selectedGaugeTye"
                :options="gaugechartType"
                label="label"
                :reduce="(label) => label.value"
                :placeholder="$t('SelectType')"
              >
        </v-select> -->

              <!-- <v-select
                class="mt-2"
                size="sm"
                v-model="selectedDepartment"
                :options="departments"
                label="department_name"
                :reduce="(department_name) => department_name.id"
                :placeholder="$t('SelectDepartment')"
              >
              </v-select> -->

              <!-- <v-select
                class="mt-2"
                v-if="selectedDepartment != 0"
                size="sm"
                v-model="selectedStaff"
                :options="staffs"
                label="first_name"
                :reduce="(first_name) => first_name.id"
                :placeholder="$t('SelectStaff')"
              >
                <template v-slot:option="option">{{
                  option.first_name + " " + option.last_name
                }}</template>
              </v-select> -->
            </div>
          </div>
        </vx-card>
        <!-- credit -->
        <div>
          <credit v-if="role == 'admin'"></credit>
        </div>
      </div>
    </b-overlay>
  </div>
</template>
<script>
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
import ChartjsBarChart from "@/components/chart/ChartjsBarChart.vue";
import ChartjsPieChart from "@/components/chart/ChartjsPieChart.vue";
import ChartjsDoughnutChart from "@/components/chart/ChartjsDoughnutChart.vue";
import ChartjsLineChart from "@/components/chart/ChartjsLineChart.vue";
import ChangeTimeDurationDropdown from "@/components/chart/ChangeTimeDurationDropdown.vue";
import moment from "moment";
import vSelect from "vue-select";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import RadialProgressBar from "vue-radial-progress";

// import Department from "@/views/company/department/Form";
import { VueTelInput } from "vue-tel-input";
import { phoneConfig, getCompanyTitles, getCompanyCol } from "@/utils/helper";
// For custom error message
import { Validator } from "vee-validate";
import Credit from "@/components/popup/Credit.vue";

import VueGauge from "vue-gauge";

export default {
  data() {
    return {
      props: {
        Statistic: {
          type: String,
        },
        dateRange: {
          type: Object,
        },
      },
      height: 280,
      selectedRevenue: "Current Month",
      selectedApp: "Current Month",
      paymentData: {},
      appointmnetData: {},
      companies: [],
      dashboard: [],
      countStaff: 0,
      countDepartment: 0,
      countAppointment: 0,
      countSms: 0,
      checkpointReward: {},
      subscribersGained: {},
      ordersRecevied: {},
      fileName: "",
      formats: ["xlsx", "csv", "txt"],
      cellAutoWidth: true,
      selectedFormat: "xlsx",
      title: [],
      values: [],
      count: 0,
      payments: [],
      headerTitle: getCompanyTitles(),
      headerVal: getCompanyCol(),
      role: this.$store.getters.roles,
      options1: [this.$t("Paid"), this.$t("NotPaid")],
      status: "",
      options: [this.$t("Department"), this.$t("Staff")],
      selected: "",
      activePrompt: false,
      dateRange: {},
      totalRevenue: 0,
      revenueData: {},
      revenueOptions: {
        responsive: true,
        legend: { display: false },
        scales: {
          yAxes: [
            {
              display: true,
              ticks: {
                beginAtZero: true,
                stepSize: 5,
              },
            },
          ],
        },
      },
      revenueTitle: "",
      appData: {},
      appOptions: {
        responsive: true,
        legend: { display: false },
        scales: {
          yAxes: [
            {
              display: true,
              ticks: {
                beginAtZero: true,
                stepSize: 5,
              },
            },
          ],
        },
      },
      appTitle: "",
      appSat: "",
      popupActivo2: false,
      popupActivo3: false,
      duration: 0,
      contact_number: "",
      phone: "",
      bindProps: phoneConfig(this.$t("ContactNumber")),
      otp_response: "",
      otpNumber: "",
      department_data: [],
      unio_user: this.$store.getters.currentUser.is_unio,
      show: false,
      variant: "light",
      opacity: 0.85,
      blur: "2px",
      error: "",
      success: "",
      sec: 2,
      counter: 0,
      countPending: 0,
      countCancelled: 0,
      countCompleted: 0,
      selectedMonth: moment().format("MMMM YYYY"),
      monthNames: moment.months(),
      selectedGaugeTye: "company",
      gaugechartType: [
        { label: "Company", value: "company" },
        { label: "Department list", value: "department_list" },
      ],
      departments: [],
      selectedDepartment: "0",
      staffs: [],
      selectedStaff: "",
      gaugeOptions: {
        hasNeedle: true,
        needleColor: "gray",
        needleUpdateSpeed: 1000,
        arcColors: ["#77d48f", "#de741d", "#e63715"],
        arcDelimiters: [50, 75],
        rangeLabel: ["0", "100"],
        centralLabel: "90",
        needleValue: "90",
        chartWidth: 500,
      },
      gaugeMobileOptions: {
        hasNeedle: true,
        needleColor: "gray",
        needleUpdateSpeed: 1000,
        arcColors: ["#77d48f", "#de741d", "#e63715"],
        arcDelimiters: [50, 75],
        rangeLabel: ["0", "100"],
        centralLabel: "90",
        needleValue: "90",
      },
      showGauge: true,
      monthArr: [],
      occupation_rate: [],
      totalSteps: 100,
      currentMonth: moment().format("MMMM YYYY")
    };
  },
  watch: {
    "$i18n.locale": {
      handler: function (value) {
        this.options = [this.$t("Department"), this.$t("Staff")];
        this.options1 = [this.$t("Paid"), this.$t("NotPaid")];
        this.getPieChartData();
        this.getAppFilterData(this.selectedApp);
        this.getRevenueFilterData(this.selectedRevenue);
        this.departments[0].department_name = this.$t("Company");
      },
    },

    selectedMonth: function () {
      this.getAllocationAlgorithChartData();
    },

    selectedDepartment: function () {
      this.selectedStaff = "";
      this.getStaffs();
      this.getAllocationAlgorithChartData();
    },

    selectedGaugeTye: function () {
      this.selectedStaff = "";
      this.selectedDepartment = "";
      this.getAllocationAlgorithChartData();
    },

    selectedStaff: function () {
      this.getAllocationAlgorithChartData();
    },
  },

  components: {
    credit: Credit,
    ChartjsPieChart,
    StatisticsCardLine,
    vSelect,
    DatePicker,
    ChartjsBarChart,
    ChangeTimeDurationDropdown,
    ChartjsDoughnutChart,
    ChartjsLineChart,
    VueGauge,
    RadialProgressBar,
  },
  mounted() {
    this.monthArr = [];
    for (var i = 10; i >= -3; i--) {
      this.monthArr.push({
        month: moment()
          .subtract(i, "months")
          .startOf("month")
          .format("MMMM YYYY"),
        date: moment()
          .subtract(i, "months")
          .startOf("month")
          .format("YYYY-MM-DD"),
      });
    }

    // Dispatched Orders
    this.options = [this.$t("Department"), this.$t("Staff")];
    this.options1 = [this.$t("Paid"), this.$t("NotPaid")];
    this.getDashboardData(
      this.$store.getters.roles == "assistant"
        ? this.$store.getters.currentUser.company_id
        : this.$store.getters.currentUser.id
    );
    this.getCompanyDashboard(
      this.$store.getters.roles == "assistant"
        ? this.$store.getters.currentUser.company_id
        : this.$store.getters.currentUser.id
    );
    this.getPieChartData();
    this.getAppFilterData("Current Month");
    this.getRevenueFilterData("Current Month");
    this.changeSplit();
    this.getAllocationAlgorithChartData();
    this.getDepartments();
  },
  methods: {
    /**
     * lang conversion
     */
    getOriginalValue(value) {
      if (value == this.$t("Department")) {
        return "Department";
      } else if (value == this.$t("Staff")) {
        return "Staff";
      }
      return "";
    },
    /**
     * payment details based on filters
     */
    changeSplit() {
      var paymentStatus = "";
      if (this.status == this.$t("Paid")) {
        paymentStatus = 1;
      }
      if (this.status == this.$t("NotPaid")) {
        paymentStatus = 0;
      }

      if (this.selected) {
        this.selected = this.getOriginalValue(this.selected);
      }

      if (this.dateRange.length != undefined) {
        var data = {
          company_id:
            this.$store.getters.roles == "assistant"
              ? this.$store.getters.currentUser.company_id
              : this.$store.getters.currentUser.id,
          split_type: this.selected ? this.selected.toLowerCase() : "",
          start_date:
            this.dateRange[0] != null
              ? moment(this.dateRange[0]).format("YYYY-MM-DD")
              : "",
          end_date:
            this.dateRange[1] != null
              ? moment(this.dateRange[1]).format("YYYY-MM-DD")
              : "",
        };
      } else {
        var data = {
          company_id:
            this.$store.getters.roles == "assistant"
              ? this.$store.getters.currentUser.company_id
              : this.$store.getters.currentUser.id,
          split_type: this.selected ? this.selected.toLowerCase() : "",
        };
      }
      if (paymentStatus == "0" || paymentStatus == "1") {
        data.status = paymentStatus;
      }
      this.selected = this.$t(this.selected);
      this.sortData(data);
    },
    /**
     * sort data
     */
    sortData(data) {
      this.payments = [];
      this.show = true;
      this.$store
        .dispatch("CompanySplitValue", data)
        .then((res) => {
          this.show = false;
          let payments = res.data.data;
          payments.forEach((element) => {
            element.payment_status =
              element.payment_status == "1"
                ? this.$t("Paid")
                : element.payment_status != undefined &&
                  element.payment_status == "0"
                ? this.$t("NotPaid")
                : this.$t("Free");
          });
          this.payments = payments;
        })
        .catch((error) => {
          this.$log.error(
            "File : Admin.vue | Function : sortData() | Error :",
            error
          );
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },
    /**
     * date range
     */

    /**
     *
     * getDashboardData   method  for company login dashboard data
     **/
    getDashboardData(company_id) {
      this.show = true;

      this.$store
        .dispatch("getDashboardData", company_id)
        .then((res) => {
          this.show = false;

          this.dashboard = res.data.data;
          this.countStaff = this.dashboard.staff_count;
          this.countAppointment = this.dashboard.appointment_count;
          this.countDepartment = this.dashboard.department_count;
          this.totalRevenue = this.dashboard.revenue;
          this.countSms = this.dashboard.sms_count;
        })
        .catch((error) => {
          this.$log.error(
            "File : CompanyDashboard.vue | Function : getCountDepartments() | Error :",
            error
          );
          this.show = false;
          // Error response
          this.error = error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });

          return false;
        });
    },

    /**
     *
     * getDashboardData   method  for company login dashboard data
     **/
    getCompanyDashboard(company_id) {
      this.show = true;

      this.$store
        .dispatch("CompanyDashboard", company_id)
        .then((res) => {
          this.show = false;
          this.department_data = res.data.data.department_data;
          this.duration = this.department_data.duration;
          this.contact_number = res.data.data.contact_number;
          this.phone = res.data.data.contact_number;
        })
        .catch((error) => {
          this.$log.error(
            "File : CompanyDashboard.vue | Function : getCountDepartments() | Error :",
            error
          );
          this.show = false;
          // Error response
          this.error = error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },
    /**
     * get revenue bar chart filter data
     */
    getRevenueFilterData(val) {
      this.selectedRevenue = val;
      let type = val.toLowerCase().replace(/\s/g, "_");

      this.revenueTitle = "Revenue";
      var data = {
        company_id:
          this.$store.getters.roles == "assistant"
            ? this.$store.getters.currentUser.company_id
            : this.$store.getters.currentUser.id,
        type: type,
      };
      this.$store
        .dispatch("GetCompanyRevenueChartData", data)
        .then((res) => {
          this.show = false;
          this.revenueData = {
            labels: Object.values(res.data.data.amount.labels),
            datasets: [
              {
                backgroundColor: "#7367F0",
                data: res.data.data.amount.values,
              },
            ],
          };
          if (this.revenueData.labels.length == 12) {
            this.revenueData.labels = this.$t("monthNames");
          }
        })
        .catch((error) => {
          this.$log.error(
            "File : dashboard.vue | Function : getRevenueFilterData() | Error :",
            error
          );
          this.show = false;
          return false;
        });
    },
    /**
     * get revenue bar chart filter data
     */
    getAppFilterData(val) {
      this.selectedApp = val;
      let type = val.toLowerCase().replace(/\s/g, "_");
      this.appTitle = "Appointments";
      var data = {
        company_id:
          this.$store.getters.roles == "assistant"
            ? this.$store.getters.currentUser.company_id
            : this.$store.getters.currentUser.id,
        type: type,
      };
      this.$store
        .dispatch("GetCompanyAppChartData", data)
        .then((res) => {
          this.show = false;
          console.log("res.data.data.labels", res.data.data.labels);
          if (res.data.data.labels.length == 12) {
            res.data.data.labels = this.$t("monthNames");
          }
          this.appData = {
            labels: Object.values(res.data.data.labels),
            datasets: [
              {
                data: res.data.data.values,
                borderColor: "#7367F0",
                fill: false,
              },
            ],
          };
        })
        .catch((error) => {
          this.$log.error(
            "File : Admin.vue | Function : getAppFilterData() | Error :",
            error
          );
          this.show = false;
          return false;
        });
    },

    /**
     * get revenue bar chart filter data
     */
    getPieChartData() {
      var data = {
        company_id:
          this.$store.getters.roles == "assistant"
            ? this.$store.getters.currentUser.company_id
            : this.$store.getters.currentUser.id,
      };
      this.$store
        .dispatch("GetAppPieChartData", data)

        .then((res) => {
          this.show = false;
          console.log(res.data.data);
          this.appSat = res.data.data;
          let temp = res.data.data;

          temp.map((el, index) => {
            if (el.status == "pending") this.countPending = el.count;
            if (el.status == "cancelled") this.countCancelled = el.count;
            if (el.status == "completed") this.countCompleted = el.count;
          });
        })
        .catch((error) => {
          this.$log.error(
            "File : admin.vue | Function : getPieChartData() | Error :",
            error
          );
          this.show = false;
          return false;
        });
    },
    // set randome colors
    getRandomColor() {
      var letters = "0123456789ABCDEF";
      var color = "#";
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },

    getAllocationAlgorithChartData() {
      this.showGauge = false;
      this.show = true;

      let index = this.monthArr.findIndex(
        (element) => element.month == this.selectedMonth
      );

      var data = {
        company_id:
          this.$store.getters.roles == "assistant"
            ? this.$store.getters.currentUser.company_id
            : this.$store.getters.currentUser.id,
        department_id:
          this.selectedDepartment != 0 ? this.selectedDepartment : "",
        staff_id: this.selectedStaff,
        dateVal: moment(this.monthArr[index].date)
          .startOf("month")
          .format("YYYY-MM"),
        start_date_val: moment(this.monthArr[index].date)
          .startOf("month")
          .format("YYYY-MM-DD"),
        end_date_val: moment(this.monthArr[index].date)
          .endOf("month")
          .format("YYYY-MM-DD"),
        start_date: moment(this.monthArr[index].date)
          .startOf("month")
          .format("DD"),
        end_date: moment(this.monthArr[index].date).endOf("month").format("DD"),
      };
      this.$store
        .dispatch("GetAllocationAlgorithChartData", data)
        .then((res) => {
          console.log("resssssssssssssss", res.data)
          this.occupation_rate = res.data.data.data;
          this.gaugeOptions.centralLabel =
            res.data.data.data.company.occupation_rate.toString();
          this.gaugeOptions.needleValue =
          res.data.data.data.company.occupation_rate.toString();

          this.gaugeMobileOptions.centralLabel =
          res.data.data.data.company.occupation_rate.toString();
          this.gaugeMobileOptions.needleValue =
          res.data.data.data.company.occupation_rate.toString();

          this.showGauge = true;
          this.show = false;
        })
        .catch((error) => {
          this.$log.error(
            "File : admin.vue | Function : getAllocationAlgorithChartData() | Error :",
            error
          );
          this.show = false;
          return false;
        });
    },

    getDepartments() {
      this.show = true;
      console.log("showDirectDepartment", this.showDirectDepartment);
      var data = {
        company_id:
          this.$store.getters.roles == "assistant"
            ? this.$store.getters.currentUser.company_id
            : this.$store.getters.currentUser.id,
        direct_filter: 1,
        order_by: "department_name",
      };

      this.$store
        .dispatch("DepartmentsWithFilter", data)
        .then((res) => {
          this.show = false;
          this.departments = res.data.department_list;
          this.departments[0].department_name = this.$t("Company");
        })
        .catch((error) => {
          this.$log.error(
            "File : List.vue | Function : getDepartments() | Error :",
            error
          );
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },

    getStaffs() {
      this.show = true;
      let data = {
        department_id: this.selectedDepartment,
        company_id:
          this.$store.getters.roles == "assistant"
            ? this.$store.getters.currentUser.company_id
            : this.$store.getters.currentUser.id,
        is_option_listing: 0,
        order_by: "first_name",
      };
      this.$store
        .dispatch("GetStaffByDepartmentId", data)
        .then((res) => {
          this.show = false;
          this.staffs = res.data.staffs;
        })
        .catch((error) => {
          this.$log.error(
            "File : List.vue | Function : getstaffs() | Error :",
            error
          );
          this.show = false;
          // Error response

          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });

          return false;
        });
    },
  },
};
</script>
<style >
.gauge .vs__clear {
  display: none !important;
}
.gauge .vs__selected {
  background: none !important;
  color: #000 !important;
  font-weight: bold;
}
.gauge .vs__dropdown-toggle {
  border: none !important;
}
.gauge .vs__dropdown-option--highlight {
  background: transparent !important;
  color: #888 !important;
}
.gauge .v-select .vs__dropdown-menu .vs__dropdown-option--highlight {
  color: #888 !important;
}
.gauge .vs__dropdown-option--selected {
  background: transparent !important;
  color: #888 !important;
}
.gauge .vs__dropdown-menu {
  border: solid 1px #ddd;
}
.gauge .vs__selected-options {
  left: 55px;
}
.gauge span.vs__selected {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* width: 100px; */
}
.gauge ::placeholder {
  width: 80px;
}
#mobile-unique-id {
  display: none;
  text-align: center;
}
#type-unique-id {
  display: block;
  text-align: center;
}
.gauge a {
  color: #fff !important;
}
.gauge .list-group-item.d-flex.align-items-center {
  border-left: 0;
  border-right: 0;
  border-color: #000;
}
.gauge .list-group-item {
    padding: 1.25rem 1.25rem;
}

.gauge .list-group-item:first-child, .gauge .list-group-item:last-child{
border-radius: 0 !important;
}

.occupation-title{
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: inline-block;
    max-width: calc(100% - 130px);
}
</style>
<style scoped>
.card {
  display: inline;
}
</style>
<style lang="scss" scoped>
a {
  color: #626262 !important;
}
.gauge a {
  color: #fff !important;
}

.v-select .vs__dropdown-toggle {
  height: 34px;
}
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user {
    position: relative;

    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }
    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
    #mobile-unique-id {
      display: block;
    }
    #type-unique-id {
      display: none;
    }
  }
}
#hide {
  visibility: hidden !important;
}
.daterangepicker {
  left: 80% !important;
}
.range {
  padding-left: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.status {
  position: relative;
  display: inline-block;
  width: 320px;
}
.action {
  margin-left: 20px;
  display: inline;
}

.con-vs-tooltip {
  display: inline;
}

.con-exemple-prompt {
  padding: 10px;
  padding-bottom: 0px;
}
.card-body {
  padding: 2.25rem !important;
}

// .vs-input {
//   width: 100%;
//   margin-top: 10px;
// }

.url {
  //  overflow-wrap: break-word;
  word-break: break-word;
}
.content {
  display: inline-flex;
}
.contact_number {
  padding: 8px !important;
}
.align-center {
  text-align: center;
}
.credit_plan {
  margin-top: 5px !important;
}
.back-color {
  background-color: rgb(170, 247, 219);
}
.pad-15 {
  padding-bottom: 1.5rem !important;
}
.custom-height {
  height: 175px;
}
.option-text-bold {
  font-weight: bold;
  color: #000;
}

/*! rtl:end:ignore */
</style>
